import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import {
  ActivatedRoute,
  NavigationEnd,
  NavigationStart,
  Params,
  Router,
} from '@angular/router';
import PerfectScrollbar from 'perfect-scrollbar';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from '../services/auth.service';

declare const $: any;

//Metadata
export interface RouteInfo {
  path: string;
  title: string;
  type: string;
  icontype: string;
  collapse?: string;
  children?: ChildrenItems[];
  inMore?: boolean;
}

/* export interface ChildrenItems {
  path: string;
  title: string;
  ab: string;
  type?: string;
} */
export interface ChildrenItems {
  path: string;
  title: string;
  ab?: string;
  type?: string;
  inMore?: boolean;
  //icontype?: string;
  //collapse?: string;
  //children?: ChildrenItems[];
}

//Menu Items
export const ROUTES: RouteInfo[] = [
  {
    path: '/dashboard',
    title: 'Dashboard',
    type: 'link',
    icontype: 'dashboard',
  },
  {
    path: '/companyInfo',
    title: 'Company',
    type: 'link',
    icontype: 'receipt',
    collapse: 'companyDocs',
  },
  {
    path: '/committee',
    title: 'Committee',
    type: 'link',
    icontype: 'receipt',
    collapse: 'committee',
  },
  /*   {
    path: '/performance',
    title: 'Performance',
    type: 'sub',
    icontype: 'trending_up',
    collapse: 'performance',
    children: [
      { path: 'conversion-rate', title: 'Conversion Rate', ab: '\u00A0' },
      { path: 'cpc', title: 'CPC', ab: '\u00A0' },
      { path: 'ctr', title: 'CTR', ab: '\u00A0' },
      { path: 'ad-campaigns', title: 'Ad Campaigns', ab: '\u00A0' },
      { path: 'seo-analytics', title: 'SEO Analytics', ab: '\u00A0' },
    ],
    inMore: false,
  }, */
  /* {
    path: '/digital-presence',
    title: 'Digital Presence',
    type: 'sub',
    icontype: 'public',
    collapse: 'digital-presence',
    children: [
      { path: 'seo-data', title: 'SEO Data', ab: '\u00A0' },
      {
        path: 'social-media-engagement',
        title: 'Social Media Engagement',
        ab: '\u00A0',
      },
      { path: 'website-analytics', title: 'Website Analytics', ab: '\u00A0' },
      {
        path: 'social-media-metrics',
        title: 'Social Media Metrics',
        ab: '\u00A0',
      },
    ],
    inMore: false,
  }, */
  {
    path: '/numbers',
    title: 'Numbers',
    type: 'link',
    icontype: 'account_balance',
    collapse: 'numbers',
    /* children: [
      { path: 'revenue', title: 'Revenue', ab: '\u00A0' },
      { path: 'net-profit', title: 'Net Profit', ab: '\u00A0' },
      { path: 'paypal', title: 'Paypal', ab: '\u00A0' },
      { path: 'stripe', title: 'Stripe ', ab: '\u00A0' },
      { path: 'square', title: 'Square ', ab: '\u00A0' },
      { path: 'plaid', title: 'Banks (Plaid)', ab: '\u00A0' },
    ], */
    inMore: false,
  },
  /* {
    path: '/billing/invoices',
    title: 'Billing',
    //type: 'sub',
    type: 'link',
    icontype: 'receipt',
    inMore: false,
  }, */
  /* {
    //path: '/accounting/personnel',
    path: '/accounting',
    title: 'Accounting (AI-Powered)',
    type: 'link',
    icontype: 'account_balance_wallet',
  }, */
  // {
  //   path: '/accounting',
  //   title: 'Accounting',
  //   type: 'link',
  //   icontype: 'account_balance_wallet',
  //   collapse: 'accounting',
  //   inMore: false,
  // },
  {
    path: '/hub',
    title: 'Touch Base',
    type: 'link',
    icontype: 'notifications',
    collapse: 'hub',
    /* children: [
      { path: 'custom-alerts', title: 'Custom Alerts', ab: '\u00A0' },
      { path: 'ai-recommendations', title: 'AI Recommendations', ab: '\u00A0' },
    ], */
    inMore: false,
  },
  {
    path: '/logistics',
    title: 'Logistics',
    type: 'link',
    icontype: 'local_shipping',
    collapse: 'logistics',
  },
  {
    path: '/marketing',
    title: 'Marketing',
    type: 'link',
    icontype: 'public',
    collapse: 'marketing',
    inMore: false,
  },
  {
    path: '/observability',
    title: 'Observability',
    type: 'link',
    icontype: 'public',
    collapse: 'observability',
    inMore: false,
  },
  /* {
    path: '/customers',
    title: 'Customers',
    type: 'link',
    icontype: 'people',
    collapse: 'customers',
  }, */
  /* {
    path: '/task-runners',
    title: 'Task Runners',
    type: 'sub',
    icontype: 'directions_run',
    collapse: 'task-runners',
    children: [
      { path: 'total-number', title: 'Total Number', ab: 'TN' },
      { path: 'by-cities', title: 'By Cities', ab: 'BC' },
      { path: 'active', title: 'Active', ab: 'A' },
      { path: 'busy', title: 'Busy', ab: 'B' },
      { path: 'pending', title: 'Pending', ab: 'P' },
      { path: 'sanctioned', title: 'Sanctioned', ab: 'S' },
    ],
  }, */
  // {
  //   path: '/customers',
  //   title: 'Customers',
  //   type: 'link',
  //   icontype: 'people',
  //   collapse: 'customers',
  // },
  // {
  //   path: '/drivers',
  //   title: 'Drivers & +',
  //   //type: 'sub',
  //   type: 'link',
  //   icontype: 'local_taxi',
  //   collapse: 'drivers',
  // },

  /* {
    path: '/subway-runner',
    title: 'Subway Runner',
    type: 'link',
    icontype: 'directions_subway',
    collapse: 'subway-runner',
  }, */
  /* {
    path: '/administracion',
    title: 'Admon',
    type: 'sub',
    icontype: 'settings',
    collapse: 'administracion',
    children: [
      { path: 'users', title: 'Dashboard Users', ab: '\u00A0' },
      { path: 'roles', title: 'Roles', ab: '\u00A0' },
      { path: 'configs', title: 'Config', ab: '\u00A0' },
      { path: 'categories', title: 'category', ab: '\u00A0' },
      //{ path: 'services', title: 'Services', ab: 'S' },
    ],
    inMore: false,
  }, */
  {
    path: '/humanResources',
    title: 'HR',
    type: 'link',
    icontype: 'settings',
    collapse: 'humanResources',
    /* children: [
      { path: 'personnel', title: 'Personnel', ab: '\u00A0' },
      { path: 'onboarding', title: 'Onboarding', ab: '\u00A0' },
      { path: 'training', title: 'Training', ab: '\u00A0' },
      { path: 'evaluation', title: 'Evaluation', ab: '\u00A0' },
      { path: 'nda', title: 'NDA & Legal', ab: '\u00A0' },
      { path: 'requests', title: 'Requests', ab: '\u00A0' },
      { path: 'activity', title: 'Activity Log', ab: '\u00A0' },
    ], */
    inMore: false,
  },
  {
    path: '/administracion',
    title: 'Team',
    type: 'link',
    icontype: 'people',
    collapse: 'administracion',
  },
  {
    path: '/registry',
    title: 'Registry',
    type: 'link',
    icontype: 'receipt',
    collapse: 'registry',
  },
  // {
  //   path: '/logistics/fees',
  //   title: 'Metrics',
  //   type: 'link',
  //   icontype: 'attach_money',
  //   collapse: 'fees',
  // },
  /* {
    path: '/administracion/roles',
    title: 'Access Profiles',
    type: 'link',
    icontype: 'people',
    collapse: 'administracion/roles',
  }, */
  /* {
    path: '/data',
    title: 'Data',
    type: 'link',
    icontype: 'bar_chart',
    collapse: 'data',
    children: [
      { path: 'total-number', title: 'Total Number', ab: 'TN' },
       {path: 'by-cities', title: 'By Cities', ab:'BC'},
            {path: 'active', title: 'Active', ab:'A'},
            {path: 'busy', title: 'Busy', ab:'B'},
            {path: 'pending', title: 'Pending', ab:'P'},
            {path: 'sanctioned', title: 'Sanctioned', ab:'S'}
    ],
  }, */
 
  {
    path: '/components',
    title: 'Components',
    type: 'sub',
    icontype: 'apps',
    collapse: 'components',
    children: [
      { path: 'buttons', title: 'Buttons', ab: '\u00A0' },
      { path: 'grid', title: 'Grid System', ab: '\u00A0' },
      { path: 'panels', title: 'Panels', ab: '\u00A0' },
      { path: 'sweet-alert', title: 'Sweet Alert', ab: '\u00A0' },
      { path: 'notifications', title: 'Notifications', ab: '\u00A0' },
      { path: 'icons', title: 'Icons', ab: '\u00A0' },
      { path: 'typography', title: 'Typography', ab: '\u00A0' },
    ],
    inMore: true,
  },
  {
    path: '/forms',
    title: 'Forms',
    type: 'sub',
    icontype: 'content_paste',
    collapse: 'forms',
    children: [
      { path: 'regular', title: 'Regular Forms', ab: '\u00A0' },
      { path: 'extended', title: 'Extended Forms', ab: '\u00A0' },
      { path: 'validation', title: 'Validation Forms', ab: '\u00A0' },
      { path: 'wizard', title: 'Wizard', ab: '\u00A0' },
    ],
    inMore: true,
  },
  {
    path: '/tables',
    title: 'Tables',
    type: 'sub',
    icontype: 'grid_on',
    collapse: 'tables',
    children: [
      { path: 'regular', title: 'Regular Tables', ab: '\u00A0' },
      { path: 'extended', title: 'Extended Tables', ab: '\u00A0' },
      { path: 'datatables.net', title: 'Datatables.net', ab: '\u00A0' },
    ],
    inMore: true,
  },
  {
    path: '/maps',
    title: 'Maps',
    type: 'sub',
    icontype: 'place',
    collapse: 'maps',
    children: [
      { path: 'google', title: 'Google Maps', ab: '\u00A0' },
      { path: 'fullscreen', title: 'Full Screen Map', ab: '\u00A0' },
      { path: 'vector', title: 'Vector Map', ab: '\u00A0' },
    ],
    inMore: true,
  },
  {
    path: '/widgets',
    title: 'Widgets',
    type: 'link',
    icontype: 'widgets',
    inMore: true,
  },
  {
    path: '/charts',
    title: 'Charts',
    type: 'link',
    icontype: 'timeline',
    inMore: true,
  },
  {
    path: '/calendar',
    title: 'Calendar',
    type: 'link',
    icontype: 'date_range',
    inMore: true,
  },
  {
    path: '/pages',
    title: 'Pages',
    type: 'sub',
    icontype: 'image',
    collapse: 'pages',
    children: [
      { path: 'pricing', title: 'Pricing', ab: '\u00A0' },
      { path: 'timeline', title: 'Timeline Page', ab: '\u00A0' },
      { path: 'login', title: 'Login Page', ab: '\u00A0' },
      { path: 'register', title: 'Register Page', ab: '\u00A0' },
      { path: 'lock', title: 'Lock Screen Page', ab: '\u00A0' },
      { path: 'user', title: 'User Page', ab: '\u00A0' },
    ],
    inMore: true,
  },
];
@Component({
  selector: 'app-sidebar-cmp',
  templateUrl: 'sidebar.component.html',
  styleUrls: ['./sidebar.component.css'],
})
export class SidebarComponent implements OnInit {
  public menuItems: any[];
  ps: any;
  userInfo: any = { firstname: '', lastname: '' };
  userImg: string = './assets/img/faces/avatar.jpg';
  id: any;
  currentActiveMenu: string | null = null;
  private scrollPosition: number = 0;
  private routerSubscription: Subscription;
  private sidebarElement: HTMLElement | null = null;
  private scrollRestoreTimer: any;

  isMobileMenu() {
    if ($(window).width() > 991) {
      return false;
    }
    return true;
  }

  constructor(
    private router: Router,
    private cdr: ChangeDetectorRef,
    private authService: AuthService,
  ) {}

  /* ngOnInit() {
    this.id = localStorage.getItem('userId');
    this.menuItems = ROUTES.filter((menuItem) => menuItem);
    // Obtener usuario logueado de localStorage
    let user = localStorage.getItem('user');
    if (user) {
      this.userInfo = JSON.parse(user);
      if (this.userInfo.img) {
        this.userImg = this.userInfo.img.startsWith('http')
          ? this.userInfo.img
          : environment.apiUrl + '/uploads/' + this.userInfo.img;
      }
    }

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Restaurar scroll después de cambio de ruta
        setTimeout(() => {
          const sidebarWrapper = document.querySelector('.sidebar-wrapper');
          if (sidebarWrapper) {
            sidebarWrapper.scrollTop = this.savedScrollTop;
          }
        }, 100);

        // Lógica específica para el dashboard
        if (event.urlAfterRedirects === '/dashboard') {
          let user = localStorage.getItem('user');
          if (user) {
            this.userInfo = JSON.parse(user);
            if (this.userInfo.img) {
              this.userImg = this.userInfo.img.startsWith('http')
                ? this.userInfo.img
                : environment.apiUrl + '/uploads/' + this.userInfo.img;
            }
          }
        }
      }
    });

    if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
      const elemSidebar = <HTMLElement>(
        document.querySelector('.sidebar .sidebar-wrapper')
      );
      this.ps = new PerfectScrollbar(elemSidebar);

      const sidebarWrapper = document.querySelector('.sidebar-wrapper');

      if (sidebarWrapper) {
        sidebarWrapper.addEventListener('scroll', () => {
          this.savedScrollTop = sidebarWrapper.scrollTop;
        });
      }
    }
    this.initializeMenus();
  } */

  ngOnInit() {
    this.id = localStorage.getItem('userId');

    // Obtener usuario logueado de localStorage
    let user = localStorage.getItem('user');
    if (user) {
      this.userInfo = JSON.parse(user);
      if (this.userInfo.img) {
        this.userImg = this.userInfo.img.startsWith('http')
          ? this.userInfo.img
          : environment.apiUrl + '/uploads/' + this.userInfo.img;
      }
    }

    // Filtrar rutas por permisos del usuario
    this.menuItems = ROUTES.map((menuItem) => {
      if (menuItem.type === 'link') {
        if (!menuItem.inMore) {
          return this.authService.hasPerms(menuItem.path) ? menuItem : null;
        } else {
          return menuItem;
        }
      }

      if (menuItem.type === 'sub') {
        if (!menuItem.inMore) {
          return this.authService.hasPerms(menuItem.path) ? menuItem : null;
        } else {
          return menuItem;
        }

        /* const filteredChildren = (menuItem.children || []).filter((child) =>
          this.authService.hasPerms(`${menuItem.path}/${child.path}`)
        );
        if (filteredChildren.length > 0) {
          return {
            ...menuItem,
            children: filteredChildren,
          };
        }
        return null; */
      }

      return null;
    }).filter((item) => item !== null);
    //this.menuItems = ROUTES.filter((menuItem) => menuItem);
    console.log('menuItems finales:', this.menuItems);

    // Suscribirse a los eventos de navegación
    this.routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        // Guardar posición antes de que inicie la navegación
        this.saveScrollPosition();
      }

      if (event instanceof NavigationEnd) {
        if (event.urlAfterRedirects === '/dashboard') {
          console.log('ants de update info');
          let user = localStorage.getItem('user');
          if (user) {
            this.userInfo = JSON.parse(user);
            if (this.userInfo.img) {
              this.userImg = this.userInfo.img.startsWith('http')
                ? this.userInfo.img
                : environment.apiUrl + '/uploads/' + this.userInfo.img;
            }
          }
        }

        // Restaurar posición después de la navegación con múltiples intentos
        this.scheduleScrollRestore();
      }
    });
  }

  ngAfterViewInit() {
    // Inicializar después de que la vista esté completamente cargada
    setTimeout(() => {
      this.initializeSidebar();
    }, 40); //
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
    if (this.scrollRestoreTimer) {
      clearTimeout(this.scrollRestoreTimer);
    }
  }

  private initializeSidebar() {
    this.sidebarElement = document.querySelector(
      '.sidebar .sidebar-wrapper',
    ) as HTMLElement;

    if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
      if (this.sidebarElement) {
        this.ps = new PerfectScrollbar(this.sidebarElement);
      }
    }

    this.initializeMenus();

    // Restaurar posición inicial
    this.restoreScrollPosition();
  }

  private scheduleScrollRestore() {
    // Limpiar timer anterior si existe
    if (this.scrollRestoreTimer) {
      clearTimeout(this.scrollRestoreTimer);
    }

    // Intentar restaurar el scroll en múltiples momentos
    const attempts = [50, 100]; //200, 300, 500

    attempts.forEach((delay) => {
      setTimeout(() => {
        this.restoreScrollPosition();
      }, delay);
    });
  }

  private saveScrollPosition(): void {
    if (!this.sidebarElement) {
      this.sidebarElement = document.querySelector(
        '.sidebar .sidebar-wrapper',
      ) as HTMLElement;
    }

    if (this.sidebarElement) {
      this.scrollPosition = this.sidebarElement.scrollTop;
      localStorage.setItem(
        'sidebarScrollPosition',
        this.scrollPosition.toString(),
      );
      console.log('Posición guardada:', this.scrollPosition);
    }
  }

  private restoreScrollPosition(): void {
    if (!this.sidebarElement) {
      this.sidebarElement = document.querySelector(
        '.sidebar .sidebar-wrapper',
      ) as HTMLElement;
    }

    const savedPosition = localStorage.getItem('sidebarScrollPosition');
    if (savedPosition) {
      this.scrollPosition = parseInt(savedPosition, 10);
    }

    if (this.sidebarElement && this.scrollPosition > 0) {
      // Forzar el scroll usando diferentes métodos
      this.sidebarElement.scrollTop = this.scrollPosition;

      // Método alternativo usando scrollTo
      if (this.sidebarElement.scrollTo) {
        this.sidebarElement.scrollTo({
          top: this.scrollPosition,
          behavior: 'auto',
        });
      }

      // Si usamos PerfectScrollbar, también actualizar
      if (this.ps) {
        this.ps.update();
      }

      console.log('Posición restaurada:', this.scrollPosition);

      // Verificar si realmente se aplicó el scroll
      setTimeout(() => {
        if (
          this.sidebarElement &&
          this.sidebarElement.scrollTop !== this.scrollPosition
        ) {
          console.log('Reintentando restaurar scroll...');
          this.sidebarElement.scrollTop = this.scrollPosition;
        }
      }, 50); //100
    }
  }

  /* updatePS(): void {
    if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
      this.ps.update();
    }
  } */

  updatePS(): void {
    if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
      if (this.ps && this.sidebarElement) {
        this.saveScrollPosition();
        this.ps.update();

        setTimeout(() => {
          this.restoreScrollPosition();
        }, 30); //100
      }
    }
  }

  isMac(): boolean {
    let bool = false;
    if (
      navigator.platform.toUpperCase().indexOf('MAC') >= 0 ||
      navigator.platform.toUpperCase().indexOf('IPAD') >= 0
    ) {
      bool = true;
    }
    return bool;
  }

  /* expandOrCollapseMenu(id) {
    let parent = document.getElementById(id + '-p');
    let child = document.getElementById(id);
    parent.ariaExpanded = parent.ariaExpanded === 'true' ? 'false' : 'true';
    child.style.height =
      child.style.height === '0px' || child.style.height === '' ? '100%' : '0';
  } */

  /*   expandOrCollapseMenu(id: string) {
    const parent = document.getElementById(id + '-p');
    const child = document.getElementById(id);

    if (!parent || !child) return;

    // Si hay un menú activo y no es el actual, cerrarlo
    if (this.currentActiveMenu && this.currentActiveMenu !== id) {
      this.closeMenu(this.currentActiveMenu);
    }

    // Toggle del menú actual
    const isCurrentlyOpen = parent.getAttribute('aria-expanded') === 'true';

    if (isCurrentlyOpen) {
      // Cerrar el menú actual
      this.closeMenu(id);
      this.currentActiveMenu = null;
    } else {
      // Abrir el menú actual
      this.openMenu(id);
      this.currentActiveMenu = id;
    }
  }

  private openMenu(id: string) {
    const parent = document.getElementById(id + '-p');
    const child = document.getElementById(id);

    if (parent && child) {
      parent.setAttribute('aria-expanded', 'true');
      child.classList.add('show');
      child.style.height = '';
      child.style.display = 'block';
    }
  }

  private closeMenu(id: string) {
    const parent = document.getElementById(id + '-p');
    const child = document.getElementById(id);

    if (parent && child) {
      parent.setAttribute('aria-expanded', 'false');
      child.classList.remove('show');
      child.style.height = '0px';
      child.style.display = 'none';
    }
  }

  // Método para inicializar el estado de todos los menús (llamar en ngOnInit)
  initializeMenus() {
    this.menuItems.forEach((item) => {
      if (item.type === 'sub') {
        this.closeMenu(item.collapse);
      }
    });
  }
 */

  expandOrCollapseMenu(id: string) {
    const parent = document.getElementById(id + '-p');
    const child = document.getElementById(id);

    if (!parent || !child) return;

    this.saveScrollPosition();

    if (this.currentActiveMenu && this.currentActiveMenu !== id) {
      this.closeMenu(this.currentActiveMenu);
    }

    const isCurrentlyOpen = parent.getAttribute('aria-expanded') === 'true';

    if (isCurrentlyOpen) {
      this.closeMenu(id);
      this.currentActiveMenu = null;
    } else {
      this.openMenu(id);
      this.currentActiveMenu = id;
    }

    // NO llamar updatePS() aquí para evitar conflictos
    // Solo actualizar si es absolutamente necesario
    if (
      window.matchMedia(`(min-width: 960px)`).matches &&
      !this.isMac() &&
      this.ps
    ) {
      setTimeout(() => {
        this.ps.update();
        this.restoreScrollPosition();
      }, 50); //200
    }
  }

  private openMenu(id: string) {
    const parent = document.getElementById(id + '-p');
    const child = document.getElementById(id);

    if (parent && child) {
      // Actualizar aria-expanded para la animación de la flecha
      parent.setAttribute('aria-expanded', 'true');

      // Agregar clase show para la transición
      child.classList.add('show');

      // Remover estilos inline que podrían interferir
      child.style.height = '';
      child.style.display = '';
    }
  }

  private closeMenu(id: string) {
    const parent = document.getElementById(id + '-p');
    const child = document.getElementById(id);

    if (parent && child) {
      parent.setAttribute('aria-expanded', 'false');

      child.classList.remove('show');

      // Limpiar estilos inline
      child.style.height = '';
      child.style.display = '';
    }
  }

  /* initializeMenus() {
    setTimeout(() => {
      this.menuItems.forEach((item) => {
        if (item.type === 'sub') {
          this.closeMenu(item.collapse);
        }
      });

      this.closeMenu('collapseMore');

      setTimeout(() => {
        this.restoreScrollPosition();
      }, 100);
    }, 200);
  } */

  initializeMenus() {
    setTimeout(() => {
      this.menuItems.forEach((item) => {
        if (item.type === 'sub') {
          this.closeMenu(item.collapse);
        }
      });

      this.closeMenu('collapseMore');

      // Restaurar posición después de inicializar
      setTimeout(() => {
        this.restoreScrollPosition();
      }, 30); //100
    }, 50); //200
  }

  logout() {
    localStorage.removeItem('sidebarScrollPosition');
    localStorage.clear();
    this.router.navigateByUrl('/pages/login');
  }
}
